/**
 * Created by inonstelman on 12/28/14.
 */

(function () {
    'use strict';

    // @ngInject
    Services.gon = function gon($window) {
        if ($window.gon) {
            return $window.gon;
        }
        return {};
    };

}());